import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './TopNavigation.css';
import React, { useEffect, useState } from 'react';
import HeaderModuleWrapper from '../30_NavigationBar/HeaderModuleWrapper';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, getGlobalDictionaryTerm } from '../../utils';
import { tealiumClickFunc } from '../../utils/tealium';
import { getUserCookie, getLatestUserCookie } from '../Login/user_session';
import { getEmptyTopPicksStorage, syncTopPicks, getTopPicks, setTopPicksStorage, getTopPicksStorage } from '../atoms/FavouriteBtn/top_picks_apis';
import { get } from '../../utils';

/** Defines the props that are populated by data from CMS */

/** Defines the props that are populated by data from CMS and application usage */

var TopLinks = function TopLinks(_ref) {
  var items = _ref.items,
    analytics = _ref.analytics;
  var _useState = useState(items),
    _useState2 = _slicedToArray(_useState, 2),
    itemMaped = _useState2[0],
    setItemMaped = _useState2[1];
  var sitecoreContext = useSitecoreContext();
  var currentLang = String(sitecoreContext && sitecoreContext.language);
  var siteName = get(sitecoreContext, 'site.name') || '';
  useEffect(function () {
    items.some(function (item, index) {
      item.active = isActive(item, index);
    });
    setItemMaped(items);
  }, [items]);
  var isActive = function isActive(item, index) {
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
      var url = window.location.pathname.replace("".concat(currentLang), '').split('/').filter(function (item) {
        return item.length;
      }).join('/');
      var body = document.querySelector('body');
      var isVDsite = body && body.classList.contains('vdsite');

      //check if corporate item active
      var isCorporateItemActive = function isCorporateItemActive(itemSiteName) {
        return !isVDsite && itemSiteName === 'dotsite';
      };
      var isFirstItemActive = index === 0 && url.length === 0;
      var itemLink = item.link.url;
      var itemSiteName = item.siteName ? item.siteName.value : '';
      var isItemActive = function isItemActive() {
        switch (itemSiteName) {
          case 'leisure':
            return itemSiteName.includes(siteName) && isFirstItemActive;
          case 'business':
            return itemSiteName.includes(siteName) && url.length === 0;
          default:
            return url.length !== 0 && itemLink.includes(url);
        }
      };
      return isVDsite ? isItemActive() : isCorporateItemActive(itemSiteName);
    } else {
      return false;
    }
  };
  return itemMaped.map(function (globalLink, index) {
    var target = globalLink.link.target;
    var rel = target && target === '_blank' ? 'noopener noreferrer' : undefined;
    var title = globalLink.label.value;
    if (target === '_blank') {
      var newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || 'Opens in a new window';
      title = "".concat(title, " | ").concat(newWindowLabel);
    }
    if (target === '') {
      target = '_self';
    }
    return /*#__PURE__*/React.createElement("a", {
      className: "top-nav__link ".concat(globalLink.active ? 'top-nav__link--active' : ''),
      "data-active": "".concat(globalLink.active),
      href: get(globalLink, 'link.url'),
      target: target,
      rel: rel,
      onClick: function onClick() {
        tealiumClickFunc(analytics.globalLinksAnalytics, "".concat(globalLink.name));
      },
      key: "top-nav-link".concat(index),
      "aria-label": title,
      title: title
    }, globalLink.label.value);
  });
};
var TopNavigation = function TopNavigation(_ref2) {
  var globalLinks = _ref2.globalLinks,
    activeLanguageName = _ref2.activeLanguageName,
    languageSelectorTitle = _ref2.languageSelectorTitle,
    accessibilitySettingsTitle = _ref2.accessibilitySettingsTitle,
    actions = _ref2.actions,
    dictionary = _ref2.dictionary,
    accountLinks = _ref2.accountLinks,
    analytics = _ref2.analytics;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var addTopPicksClass = function addTopPicksClass() {
    var topPicks = getTopPicksStorage();
    if (topPicks && topPicks.list && topPicks.list.length) {
      if (canUseDOM) {
        document.body.classList.add('has--favourites');
      }
    }
  };
  React.useEffect(function () {
    if (getUserCookie().login_status) {
      getLatestUserCookie().then(function (userCookie) {
        if (userCookie.login_status) {
          if (!userCookie.error) {
            var topPicks = getTopPicksStorage();
            if (topPicks.sync) {
              getTopPicks(userCookie.access_token).then(function (topPicks) {
                if (!topPicks.failed) {
                  var obj = getTopPicksStorage();
                  obj.list = topPicks || [];
                  setTopPicksStorage(obj);
                  addTopPicksClass();
                } else {
                  addTopPicksClass();
                }
              });
            } else {
              syncTopPicks(userCookie.access_token).then(function (result) {
                if (result) {
                  getTopPicks(userCookie.access_token).then(function (topPicks) {
                    if (!topPicks.failed) {
                      setTopPicksStorage(getEmptyTopPicksStorage(topPicks));
                    } else {
                      addTopPicksClass();
                    }
                  });
                } else {
                  addTopPicksClass();
                }
              });
            }
          } else {
            addTopPicksClass();
          }
        } else {
          addTopPicksClass();
        }
      });
    } else {
      addTopPicksClass();
    }
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "top-nav"
  }, globalLinks.targetItem && globalLinks.targetItem.children && /*#__PURE__*/React.createElement(TopLinks, {
    analytics: analytics,
    items: globalLinks.targetItem.children
  })))));
};
export default TopNavigation;
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl,
    className = _ref3.className;
  return /*#__PURE__*/React.createElement(HeaderModuleWrapper, {
    className: "top-navigation-component ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className)
  }, children);
};
var commonStyles = "c1p618zp";
var ltrStyles = "ln7p0i3";
var rtlStyles = "r67msif";